/**
 * Updates' and Workflows' list: flat while every item is on one side, else
 * the ones that need a hand (open, matching the tab's count) over the rest
 * (folded).
 *
 * @module components/home/HomeSplitList
 */
import type { ReactNode } from "react";

import { ListSection } from "../ui/list-section";
import type { SplitList } from "./homeTabs.logic";

export function HomeSplitList<T>({
  list,
  labels,
  row,
}: {
  readonly list: SplitList<T>;
  readonly labels: { readonly needsHand: string; readonly rest: string };
  readonly row: (item: T) => ReactNode;
}) {
  if (list.kind === "flat") return <>{list.items.map(row)}</>;
  return (
    <>
      <ListSection label={labels.needsHand} count={list.needsHand.length}>
        {list.needsHand.map(row)}
      </ListSection>
      <ListSection label={labels.rest} count={list.restCount} defaultOpen={false}>
        {list.rest.map(row)}
      </ListSection>
    </>
  );
}
